import React, { useState, useEffect } from 'react'
import ReactMapboxGl, { Feature, Layer, Popup } from 'react-mapbox-gl'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, Typography } from '@material-ui/core'
import { mapCenterOrBoundsSelector, selectedLocationSelector, setSelectedLocation } from '../slices/locator'

import baLogo from '../images/ba-logo.png'

const MapboxMap = ReactMapboxGl( {
  accessToken : process.env.REACT_APP_MAPBOX_TOKEN,
} )

const circleLayout = {
  visibility : 'visible',
  'icon-image' : 'ba-logo',
  'icon-size' : 0.10,
  'icon-allow-overlap' : true,
}

export default function Map( { locations } ) {
  const dispatch = useDispatch()
  const { bounds } = useSelector( mapCenterOrBoundsSelector )
  const selectedLocation = useSelector( selectedLocationSelector )
  const [ images, setImages ] = useState( null )

  const onMapClick = ( map, evt ) => {
    const feature = map.queryRenderedFeatures( evt.point, { layers : [ 'locations' ] } )?.[0]

    if ( feature ) {
      const location = locations.find( ( loc ) => loc.id === feature.properties.storeId )
      dispatch( setSelectedLocation( location ) )
    } else {
      dispatch( setSelectedLocation( null ) )
    }
  }

  useEffect( () => {
    const image = new Image()

    image.onload = () => {
      setImages( [ 'ba-logo', image ] )
    }

    image.src = baLogo
  }, [] )

  return (
    <MapboxMap
      // eslint-disable-next-line react/style-prop-object
      style="mapbox://styles/mapbox/dark-v10"
      containerStyle={{ height : '100%', width : '100%' }}
      // center={center}
      onClick={onMapClick}
      fitBounds={bounds}
      fitBoundsOptions={{ padding : 100 }}
      flyToOptions={{ maxDuration : 1500 }}
    >
      {images && (
        <Layer
          id="locations"
          type="symbol"
          layout={circleLayout}
          images={images}
        >
          {locations.map( ( location ) => (
            <Feature
              id={location.id}
              key={location.id}
              // onClick={onMapClick}
              properties={{ storeId : location.id, name : location.name }}
              coordinates={[ location.longitude, location.latitude ]}
            />
          ) )}
        </Layer>
      )}
      {selectedLocation && (
        <Popup
          coordinates={[ selectedLocation.longitude, selectedLocation.latitude ]}
        >
          <Grid container direction="column">
            <Typography variant="h6">
              <a
                target="_blank"
                href={`https://google.com/maps/search/${selectedLocation.name.replace( /\s/g, '+' )}/@${selectedLocation.latitude},${selectedLocation.longitude}`}
                rel="noreferrer"
              >
                {selectedLocation.name}
              </a>
            </Typography>
            <Typography variant="subtitle1">
              {selectedLocation.street}
            </Typography>
            <Typography variant="subtitle1">
              {`${selectedLocation.city}, ${selectedLocation.state} ${selectedLocation.zip}`}
            </Typography>
            <a
              target="_blank"
              href={`https://google.com/maps/search/${selectedLocation.name.replace( /\s/g, '+' )}/@${selectedLocation.latitude},${selectedLocation.longitude}`}
              rel="noreferrer"
            >
              Directions
            </a>
          </Grid>
        </Popup>
      )}
    </MapboxMap>
  )
}
